export default "__VITE_ASSET__Djk_4Xwz__"